// typesenseAdapter.ts
import TypesenseInstantSearchAdapter from 'typesense-instantsearch-adapter'

const typesenseInstantsearchAdapter = new TypesenseInstantSearchAdapter({
  server: {
    apiKey: `${process.env.NEXT_PUBLIC_TYPESENSE_SERACH_ONLY_API_KEY}`,
    nodes: [
      {
        host: `${process.env.NEXT_PUBLIC_TYPESENSE_HOST}`,
        port: Number(process.env.NEXT_PUBLIC_TYPESENSE_PORT),
        protocol: `${process.env.NEXT_PUBLIC_TYPESENSE_PROTOCOL}`,
      },
    ],
  },
  additionalSearchParameters: {
    per_page: 0,
    query_by:
      'fullName,region,state,status,organizations.name,universities.acronym,profileSections.text',
    query_by_weights: '100,100,100,100,100,100,1',
    sort_by: '_text_match:desc,createdAt:desc',
    exclude_fields: 'profileSections',
    highlight_fields: 'none',
    highlight_full_fields: 'none',
  },
})

export const searchClient = typesenseInstantsearchAdapter.searchClient